webpackJsonp([3,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Flickity = __webpack_require__(106);
	var smoothScroll = __webpack_require__(115);
	var opinionSlider = document.querySelector('.js-opinion_slider');
	
	new Flickity(opinionSlider, {
	  pageDots: true,
	  freeScroll: false,
	  wrapAround: true,
	  cellAlign: 'center',
	  prevNextButtons: false
	});
	
	smoothScroll.init({
	  selector: '[data-scroll]',
	  speed: 700,
	  easing: 'easeOutQuint',
	  offset: 0,
	  updateURL: true
	});

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/application.d8cd94c5baf2f50c68b9.js
 **/